import { render, staticRenderFns } from "./Select2.vue?vue&type=template&id=3c676dca&"
import script from "./Select2.vue?vue&type=script&lang=js&"
export * from "./Select2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\websites\\newshop\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c676dca')) {
      api.createRecord('3c676dca', component.options)
    } else {
      api.reload('3c676dca', component.options)
    }
    module.hot.accept("./Select2.vue?vue&type=template&id=3c676dca&", function () {
      api.rerender('3c676dca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Select2.vue"
export default component.exports